import { deleteDefinition } from 'state/grid/util';
import {
  RECEIVE_DATA,
  REQUEST_DATA,
  SET_DEFINITION,
  SET_DEFINITIONS,
  DELETE_DEFINITION,
  REQUEST_BETA_SBS_DATA,
  RECEIVE_BETA_SBS_DATA,
} from "./actions";
import SelectionState from 'state/selections/SelectionState';
import { SummaryType } from '@ls/grouping-service';
import { COMMIT_SELECTIONS } from 'state/selections/actions';
import { produce } from 'immer';

const defaultState = {
  definitions: {
    [SelectionState.UNCOMMITTED]: [],
    [SelectionState.COMMITTED]: []
  },
  fetchingData: {
    [SummaryType.ABSOLUTE]: false,
    [SummaryType.RELATIVE]: false,
  },
  data: {
    [SummaryType.ABSOLUTE]: null,
    [SummaryType.RELATIVE]: null
  },
  fetchingBetaSbsData: {
    [SummaryType.ABSOLUTE]: false,
    [SummaryType.RELATIVE]: false,
  },
  betaSbsData: {
    [SummaryType.ABSOLUTE]: null,
    [SummaryType.RELATIVE]: null,
  },
};

export default produce((state = defaultState, action) => {
  switch (action.type) {
    case SET_DEFINITION: {
      const { definition, idx } = action;
      const selectedDefinitions = state.definitions[SelectionState.UNCOMMITTED];
      if (definition === null) {
        selectedDefinitions.splice(idx, 1);
      } else {
        selectedDefinitions[idx] = definition;
      }
      break;
    }
    case DELETE_DEFINITION:
      state.definitions = deleteDefinition(state.definitions, action.payload);
      break;
    case SET_DEFINITIONS: {
      state.definitions[SelectionState.UNCOMMITTED] = action.definitions;
      break;
    }
    case COMMIT_SELECTIONS: {
      state.betaData = defaultState.betaData;
      state.definitions[SelectionState.COMMITTED] = state.definitions[SelectionState.UNCOMMITTED];
      break;
    }
    case REQUEST_DATA: {
      state.fetchingData[action.summary] = true;
      state.data[action.summary] = defaultState.data[action.summary];
      break;
    }
    case RECEIVE_DATA: {
      state.fetchingData[action.summary] = false;
      state.data[action.summary] = action.data;
      break;
    }
    case REQUEST_BETA_SBS_DATA: {
      state.fetchingBetaSbsData[action.summary] = true;
      state.betaSbsData[action.summary] =
        defaultState.betaSbsData[action.summary];
      break;
    }
    case RECEIVE_BETA_SBS_DATA: {
      state.fetchingBetaSbsData[action.summary] = false;
      state.betaSbsData[action.summary] = action.data;
      break;
    }
    default:
      return state;
  }
});
